{
  "title": "Seguimiento de actividad",
  "manageFiltersButton": "Administrar filtros",
  "refreshButton": "Actualizar",
  "exportReportButton": "Exportar informe",
  "ariaLabel": "tabs de actividad",
  "tabs": {
    "weeklyActivity": "Actividad semanal",
    "recentActivity": "Actividad reciente",
    "fboActivity": "Actividad FBO"
  },
  "dialog": {
    "title": "Administrar filtros de actividad"
  },
  "errors": {
    "loadFailed": "Error al cargar datos de actividad"
  }
}
